import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const app = initializeApp({
  apiKey:            'AIzaSyCJGY6vvRuUy0pT00ZZHrvLQ7BF5ia1lJc',
  authDomain:        isLocalhost ? 'cedar-resumes-a9fdd.firebaseapp.com' : 'www.cedarresumes.com',
  projectId:         'cedar-resumes-a9fdd',
  storageBucket:     'cedar-resumes-a9fdd.firebasestorage.app',
  messagingSenderId: '276732130450',
  appId:             '1:276732130450:web:921c26315aa4587df3224b',
  measurementId:     'G-7309T9VERT',
});

getAnalytics(app);

export function signInWithGoogle() {
  return signInWithPopup(getAuth(app), new GoogleAuthProvider());
}

export function signOutUser() {
  return signOut(getAuth(app));
}

export function onAuthChange(cb) {
  return onAuthStateChanged(getAuth(app), cb);
}

export async function loadProjectsFromDB(userId) {
  const ref  = doc(getFirestore(app), 'projects', userId);
  const snap = await getDoc(ref);
  return snap.exists() ? (snap.data().projects ?? []) : null;
}

export async function saveProjectsToDB(userId, projects) {
  const ref = doc(getFirestore(app), 'projects', userId);
  await setDoc(ref, { projects, updatedAt: new Date().toISOString() }, { merge: true });
}